import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import { GAUTH_REQUEST, GAUTH_ENABLE, GAUTH_DISABLE } from 'redux/actions/gAuth';

import { LOAD_PROFILE_SUCCESS, SAVE_REFERRAL_ID } from 'redux/actions/profile';

export const GET_USER_TEMP_AUTH_TOKEN = 'GET_USER_TEMP_AUTH_TOKEN';
export const CLEAR_USER_TEMP_AUTH_TOKEN = 'CLEAR_USER_TEMP_AUTH_TOKEN';
export const SEND_EMAIL_OTP_SUCCESS = 'SEND_EMAIL_OTP_SUCCESS';
export const SEND_EMAIL_OTP_FAIL = 'SEND_EMAIL_OTP_FAIL';
export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const USER_AUTHENTICATED = 'USER_AUTHENTICATED';
export const USER_NOT_AUTHENTICATED = 'USER_NOT_AUTHENTICATED';
export const RESET_TEMP_AUTH = 'RESET_TEMP_AUTH';
export const SAVE_AUTHENTICATED_EMAIL = 'SAVE_AUTHENTICATED_EMAIL';

const initialState = {
  isLoading: false,
  isAuthenticated: false,
  authorization: null,
  tempAuthToken: null,
  twoFaMethod: false,
  gAuthEnabled: false,
  gAuthSecretKey: null,
  gAuthQrCode: null,
  referralId: '',
  deviceVerificationRequired: false,
  authenticatedEmail: '',
};

const initialAuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_TEMP_AUTH_TOKEN:
      return {
        ...state,
        isAuthenticated: false,
        tempAuthToken: action.payload.tempAuthToken,
        twoFaMethod: action.payload.twoFAMehtod,
        deviceVerificationRequired: action.payload.deviceVerificationRequired,
      };
    case USER_AUTHENTICATED:
      return {
        ...state,
        tempAuthToken: null,
        twoFaMethod: null,
        isAuthenticated: true,
        authorization: action.payload.bearerToken,
      };
    case SEND_EMAIL_OTP_FAIL:
      return {
        ...state,
        isAuthenticated: false,
        tempAuthToken: null,
        twoFaMethod: null,
        authorization: null,
      };
    case LOAD_PROFILE_SUCCESS:
      return { ...state, gAuthEnabled: action.payload.is2FAEnabled };
    case GAUTH_REQUEST.STARTED:
      return { ...state, isLoading: true };
    case GAUTH_REQUEST.SUCCESS:
      return {
        ...state,
        isLoading: false,
        gAuthSecretKey: action.payload.pairingCode,
        gAuthQrCode: action.payload.qrCode,
      };
    case GAUTH_REQUEST.FAIL:
      return {
        ...state,
        isLoading: false,
        gAuthSecretKey: null,
        gAuthQrCode: null,
      };
    case GAUTH_ENABLE.STARTED:
      return { ...state, isLoading: true, gAuthEnabled: false };
    case GAUTH_ENABLE.SUCCESS:
      return { ...state, isLoading: false, gAuthEnabled: true };
    case GAUTH_ENABLE.FAIL:
      return { ...state, isLoading: false, gAuthEnabled: false };
    case GAUTH_DISABLE.STARTED:
    case GAUTH_DISABLE.FAIL:
      return { ...state, gAuthEnabled: true };
    case GAUTH_DISABLE.SUCCESS:
      return {
        ...state,
        gAuthEnabled: false,
        gAuthSecretKey: null,
        gAuthQrCode: null,
      };
    case USER_NOT_AUTHENTICATED:
      return { ...initialState };
    case SAVE_REFERRAL_ID:
      return { ...state, referralId: action.payload };
    case SAVE_AUTHENTICATED_EMAIL:
      return { ...state, authenticatedEmail: action.payload };

    case RESET_TEMP_AUTH:
      return { ...state, tempAuthToken: null };
    default:
      return state;
  }
};

const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['isAuthenticated', 'authorization', 'gAuthEnabled', 'referralId'],
};

export const authReducer = persistReducer(authPersistConfig, initialAuthReducer);
